/** @typedef textStrings single set: simple array [id, text, x, y, anchorX, anchorY]*/

/** @typedef textStrings for muliple sets: 
 * textStrings: {
 *   remote: [{
 *     id: 'city1',
       text: '<b>formatted text</b> with <br>line breaks',
*     desktop: {
*       x,y,anchorX, anchorY
*     },
*     mobile: {
*       x,y,anchorX, anchorY
*     }, 
*   ...],
*   close: [{
*     desktop: {
*       x,y,anchorX, anchorY
*     },
*     mobile: {
*       x,y,anchorX, anchorY
*     }
*    },
*   ...]
*   }
*/

export const configCases = {
	bakhmut1: {
		title: 'Railway College',
		subtitle: 'Bakhmut, Myru Street 6',
		description:
			'One of the oldest educational institutions in Ukraine and the largest railway college. The building is over 120 years old. The college continues to operate, but has moved to the city of Dnepr, which is controlled by Ukraine.',
		details: ['Destroyed October 14, 2022', 'Shelling'],
		years: ['07.22', '06.23'],
		connector_line: {
			left: 0.34,
			height: 0.31
		},
		textStrings: {
			before: [
				{
					id: 'bakhmut47',
					text: 'College building',
					anchor_x: false,
					anchor_y: false,
					desktop: {
						x: 312,
						y: 316
					},
					mobile: {
						x: 313,
						y: 434
					},
					hideOnMobile: false,
					is_placemark: true,
					is_prominent: true
				}
			],
			after: [
				{
					id: 'bakhmut41',
					text: 'Destroyed residential buildings',
					anchor_x: 'end',
					anchor_y: 'end',
					desktop: {
						x: 330,
						y: 200
					},
					mobile: {
						x: 350,
						y: 210
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'bakhmut47',
					text: 'College building',
					anchor_x: false,
					anchor_y: false,
					desktop: {
						x: 312,
						y: 316
					},
					mobile: {
						x: 313,
						y: 434
					},
					hideOnMobile: false,
					is_placemark: true,
					is_prominent: true
				}
			]
		}
	},
	mariupol1: {
		title: 'Mariupol Theater',
		subtitle: "Mariupol, Teatral'na Square 1",
		description:
			"The theater was Mariupol's most famous building. Mid-morning on March 16, it was hit by a Russian airstrike. Human Rights Watch estimates that several hundred people were in the theater at the time of the attack, and at least 15 were killed.",
		details: ['Destroyed March 16, 2022', 'Air Attack'],
		years: ['01.22', '08.22'],
		connector_line: {
			left: 0.34,
			height: 0.31
		},
		textStrings: {
			before: [
				{
					id: 'mariupol16',
					text: "Theatral'na square",
					anchor_x: 'start',
					anchor_y: 'center',
					desktop: {
						x: 145,
						y: 91
					},
					mobile: {
						x: 88,
						y: 100
					},
					hideOnMobile: false,
					is_placemark: true,
					is_prominent: true
				},
				{
					id: 'mariupol17',
					text: 'Theater',
					anchor_x: 'center',
					anchor_y: 'center',
					desktop: {
						x: 154,
						y: 171
					},
					mobile: {
						x: 173,
						y: 220
					},
					hideOnMobile: false,
					is_placemark: true
				},
				{
					id: 'mariupol15',
					text: 'Water fountain',
					anchor_x: 'start',
					anchor_y: 'center',
					desktop: {
						x: 350,
						y: 285
					},
					mobile: {
						x: 430,
						y: 380
					},
					hideOnMobile: false,
					is_placemark: false
				}
			],
			after: [
				{
					id: 'mariupol8',
					text: 'Charred buildings',
					anchor_x: 'center',
					anchor_y: 'start',
					desktop: {
						x: 486,
						y: 363
					},
					mobile: {
						x: 470,
						y: 100
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'mariupol15',
					text: 'Water fountain',
					anchor_x: 'start',
					anchor_y: 'center',
					desktop: {
						x: 350,
						y: 285
					},
					mobile: {
						x: 430,
						y: 380
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'mariupol16',
					text: "Theatral'na square",
					anchor_x: 'start',
					anchor_y: 'center',
					desktop: {
						x: 145,
						y: 91
					},
					mobile: {
						x: 88,
						y: 100
					},
					hideOnMobile: false,
					is_placemark: true,
					is_prominent: true
				},
				{
					id: 'mariupol17',
					text: 'Theater',
					anchor_x: 'center',
					anchor_y: 'center',
					desktop: {
						x: 154,
						y: 171
					},
					mobile: {
						x: 173,
						y: 220
					},
					hideOnMobile: false,
					is_placemark: true
				}
			]
		}
	},
	sievierodonetsk1: {
		title: 'Ice Palace of Sports',
		subtitle: 'Sievierodonetsk, Mayakovskogo Street 28',
		description:
			'The Ice Sports Palace for 5000 visitors was one of the symbols of Sievierodonetsk. It was burned down and destroyed during the battles for the city.',
		details: ['Destroyed June 6, 2022', 'Shelling'],
		years: ['03.21', '06.22'],
		connector_line: {
			left: 0.34,
			height: 0.31
		},
		textStrings: {
			before: [
				{
					id: 'sievierodonetsk33',
					text: 'Ice Palace of Sports',
					anchor_x: false,
					anchor_y: false,
					desktop: {
						x: 272,
						y: 75
					},
					mobile: {
						x: 155,
						y: 104
					},
					hideOnMobile: false,
					is_placemark: true,
					is_prominent: true
				}
			],
			after: [
				{
					id: 'sievierodonetsk31',
					text: 'The stadium’s entire roof collapsed',
					anchor_x: 'start',
					anchor_y: 'start',
					desktop: {
						x: 428,
						y: 260
					},
					mobile: {
						x: 350,
						y: 430
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'sievierodonetsk33',
					text: 'Ice Palace of Sports',
					anchor_x: false,
					anchor_y: false,
					desktop: {
						x: 272,
						y: 75
					},
					mobile: {
						x: 155,
						y: 104
					},
					hideOnMobile: false,
					is_placemark: true,
					is_prominent: true
				}
			]
		}
	},
	kherson1: {
		title: 'Gymnasium 20',
		subtitle: "Kherson, Dzerzhyns'koho Sreet, 2",
		description:
			'The gymnasium, more than 200 years old, was shelled four times. The last time destroyed it completely. More than 1000 children learned there before the invasion.',
		details: ['Destroyed October 12, 2023', 'Shelling'],
		years: ['2022', '2023'],
		connector_line: {
			left: 0.34,
			height: 0.31
		},
		textStrings: {
			before: [
				{
					id: 'kherson57',
					text: 'Gymnasium No. 20',
					anchor_x: false,
					anchor_y: false,
					desktop: {
						x: 144,
						y: 140
					},
					mobile: {
						x: 150,
						y: 130
					},
					hideOnMobile: false,
					is_placemark: true,
					is_prominent: true
				}
			],
			after: [
				{
					id: 'kherson57',
					text: 'Gymnasium No. 20',
					anchor_x: false,
					anchor_y: false,
					desktop: {
						x: 144,
						y: 140
					},
					mobile: {
						x: 150,
						y: 130
					},
					hideOnMobile: false,
					is_placemark: true,
					is_prominent: true
				},
				{
					id: 'kherson58',
					text: 'Entrance collapsed',
					anchor_x: 'start',
					anchor_y: 'center',
					desktop: {
						x: 300,
						y: 237
					},
					mobile: {
						x: 360,
						y: 250
					},
					hideOnMobile: false,
					is_placemark: false
				},
				{
					id: 'kherson59',
					text: 'Roof destroyed',
					anchor_x: 'start',
					anchor_y: 'center',
					desktop: {
						x: 300,
						y: 303
					},
					mobile: {
						x: 360,
						y: 335
					},
					hideOnMobile: false,
					is_placemark: false
				}
			]
		}
	}
}
